import { Popover, Tooltip } from '@mui/material';
import play_icon from '../../assets/images/play_icon.svg';
import { IOSSwitch } from '../../components/IOSSwitch';
import lightbulb_icon from '../../assets/images/lightbulb_icon.svg';
import filter_icon from '../../assets/images/filter_icon.svg';
import { useState } from 'react';

export const MobileOutliersButton = (props) => {
	const {
		setIsLive,
		isPlacedUnplacedOpen,
		allBetsOpen,
		isPlacedAnchorEl,
		setAllBetsOpen,
		isFiltersOpen,
		isLive,
		setIsPlacedUnplacedOpen,
		setIsPlacedAnchorEl,
		setRefreshCounter,
		refreshCounter,
		setIsFiltersOpen,
		setIsLoading,
		isScannable,
		setIsAutoRefresh,
		isAutoRefresh,
		// Sorting props
		order,
		setOrder,
		orderBy,
		setOrderBy,
	} = props;

	const [isSortingOpen, setIsSortingOpen] = useState(false);
	const [sortingAnchorEl, setSortingAnchorEl] = useState(null);

	return (
		<div style={{ width: '100%', paddingLeft: '8px', paddingRight: '8px', boxSizing: 'border-box' }}>
			{/* Top row: Pregame/Live, All Bets, Customize */}
			<div style={{ 
				display: 'flex', 
				flexDirection: 'row', 
				gap: '6px', 
				width: '100%', 
				marginTop: '8px', 
				alignItems: 'stretch',
				boxSizing: 'border-box'
			}}>
				{/* Pregame/Live Toggle */}
				<div className="flex flex-row rounded-xl filter-button2" style={{ 
					flex: 1, 
					height: '44px', 
					alignItems: 'center', 
					justifyContent: 'center',
					maxWidth: 'calc(40% - 3px)',
					padding: '4px'
				}}>
					<div 
						onClick={() => setIsLive(false)} 
						className={`cursor-pointer ${!isLive && 'filter-button-highlighted'}`} 
						style={{ 
							height: '36px', 
							display: 'flex', 
							alignItems: 'center', 
							padding: '0 12px',
							fontSize: '13px',
							fontWeight: '500',
							borderRadius: '0.75rem',
							transition: 'all 0.2s ease'
						}}>
						Pregame
					</div>
					<div
						onClick={() => setIsLive(true)}
						className={`cursor-pointer ${isLive && 'filter-button-highlighted'}`}
						style={{ 
							height: '36px', 
							display: 'flex', 
							alignItems: 'center',
							padding: '0 12px',
							fontSize: '13px',
							fontWeight: '500',
							borderRadius: '0.75rem',
							transition: 'all 0.2s ease'
						}}>
						Live
					</div>
				</div>

				{/* All Bets Dropdown */}
				<div
					onClick={(e) => {
						setIsPlacedAnchorEl(e.currentTarget);
						setIsPlacedUnplacedOpen(!isPlacedUnplacedOpen);
					}}
					className="flex flex-row filter-button cursor-pointer"
					style={{ 
						flex: 1, 
						height: '44px',
						alignItems: 'center', 
						justifyContent: 'center', 
						borderRadius: '0.75rem',
						borderBottomLeftRadius: isPlacedUnplacedOpen ? 0 : '0.75rem',
						borderBottomRightRadius: isPlacedUnplacedOpen ? 0 : '0.75rem',
						minWidth: '80px',
						maxWidth: 'calc(30% - 3px)',
						background: '#22262e',
						transition: 'all 0.2s ease-in-out',
						boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
						padding: '0 12px'
					}}>
					<img width={16} src={lightbulb_icon} alt="icon" style={{ opacity: 0.9, marginRight: '6px' }} />
					<div style={{ fontSize: '12px', fontWeight: '500', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
						{allBetsOpen === 'all' && 'All'}
						{allBetsOpen === 'unplaced' && 'Unplaced'}
						{allBetsOpen === 'placed' && 'Placed'}
					</div>
				</div>

				<Popover
					anchorEl={isPlacedAnchorEl}
					open={isPlacedUnplacedOpen}
					onClose={() => {
						setIsPlacedUnplacedOpen(false);
					}}
					sx={{
						'& .MuiPaper-root': {
							backgroundColor: '#22262e',
							borderTopRightRadius: '0.75rem',
							borderBottomLeftRadius: '0.75rem',
							borderBottomRightRadius: '0.75rem',
							boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
						},
					}}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
					transformOrigin={{ vertical: 'top', horizontal: 'center' }}>
					<div className="rounded-xl" style={{ backgroundColor: '#22262e', width: 120 }}>
						<div
							onClick={() => {
								setAllBetsOpen('all');
								setIsPlacedUnplacedOpen(false);
							}}
							className={`p-3 filter-button cursor-pointer ${allBetsOpen === 'all' && 'filter-button-highlighted'}`}
							style={{ 
								color: 'white', 
								borderTopLeftRadius: '0.75rem', 
								borderTopRightRadius: '0.75rem',
								fontSize: '12px',
								fontWeight: '500',
								transition: 'background-color 0.2s ease'
							}}>
							All Bets
						</div>
						<div
							onClick={() => {
								setAllBetsOpen('unplaced');
								setIsPlacedUnplacedOpen(false);
							}}
							className={`p-3 filter-button cursor-pointer ${allBetsOpen === 'unplaced' && 'filter-button-highlighted'}`}
							style={{ 
								color: 'white',
								fontSize: '12px',
								fontWeight: '500',
								transition: 'background-color 0.2s ease'
							}}>
							Unplaced
						</div>
						<div
							onClick={() => {
								setAllBetsOpen('placed');
								setIsPlacedUnplacedOpen(false);
							}}
							className={`p-3 filter-button cursor-pointer ${allBetsOpen === 'placed' && 'filter-button-highlighted'}`}
							style={{ 
								color: 'white', 
								borderBottomLeftRadius: '0.75rem', 
								borderBottomRightRadius: '0.75rem',
								fontSize: '12px',
								fontWeight: '500',
								transition: 'background-color 0.2s ease'
							}}>
							Placed
						</div>
					</div>
				</Popover>

				{/* Customize Button */}
				<div
					onClick={() => {
						setIsFiltersOpen(!isFiltersOpen);
					}}
					className={`filter-button rounded-xl cursor-pointer flex flex-row ${isFiltersOpen && 'filter-button-highlighted'} filter-button-tutorial`}
					style={{ 
						flex: 1, 
						height: '44px', 
						alignItems: 'center', 
						justifyContent: 'center', 
						padding: '0 16px', 
						maxWidth: 'calc(30% - 3px)'
					}}>
					<img src={filter_icon} alt="filter icon" style={{ width: 16, height: 16, marginRight: '6px' }} />
					<div style={{ fontSize: '12px', fontWeight: '500' }}>Customize</div>
				</div>
			</div>

			{/* Second row: Scan and Auto Refresh (left side) and Sort (right side) */}
			<div style={{ 
				display: 'flex', 
				flexDirection: 'row', 
				alignItems: 'center', 
				justifyContent: 'space-between',
				marginTop: '12px', 
				width: '100%',
				boxSizing: 'border-box'
			}}>
				{/* Left side controls - Scan and Auto Refresh */}
				<div style={{ 
					display: 'flex', 
					flexDirection: 'row', 
					gap: '8px',
					flex: '0 0 auto'
				}}>
					{/* Scan button */}
					<Tooltip title={!isScannable ? `Finish selecting filters. At least one sportsbook must be selected.` : ''}>
						<button
							onClick={async () => {
								if (isScannable) {
									setRefreshCounter(refreshCounter + 1);
									setIsFiltersOpen(false);
									setIsLoading(true);
								}
							}}
							style={{
								cursor: isScannable ? 'pointer' : 'default',
								width: '100px',
								height: '44px',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								background: isScannable ? 'linear-gradient(90deg, #1e6ffc 0%, #2879ff 100%)' : '#363844',
								border: 'none',
								borderRadius: '0.75rem',
								color: 'white',
								fontSize: '12px',
								fontWeight: '600',
								transition: 'all 0.2s ease',
								outline: 'none',
								boxShadow: 'none'
							}}
							disabled={!isScannable}>
							<span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
								<img src={play_icon} alt="play icon" style={{ width: 18, height: 18, marginRight: '8px' }} />
								<span>Scan</span>
							</span>
						</button>
					</Tooltip>
					<button
						onClick={() => setIsAutoRefresh(!isAutoRefresh)}
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							height: '44px',
							paddingLeft: '12px',
							paddingRight: '12px',
							border: '2px solid #444',
							borderRadius: '0.75rem',
							background: isAutoRefresh ? '#282e36' : 'transparent',
							color: '#b1b6c3',
							fontWeight: '500',
							fontSize: '12px',
							transition: 'all 0.2s ease',
							outline: 'none',
							boxShadow: 'none',
							cursor: 'pointer',
							whiteSpace: 'nowrap',
							minWidth: '80px',
							maxWidth: '100px'
						}}>
						Auto Refresh
					</button>
				</div>

				{/* Right side controls - Sort */}
				<div style={{ 
					display: 'flex', 
					flexDirection: 'row', 
					gap: '8px',
					flex: '0 0 auto'
				}}>
					{/* Sort dropdown - wider with larger font */}
					<div
						onClick={(e) => {
							setSortingAnchorEl(e.currentTarget);
							setIsSortingOpen(!isSortingOpen);
						}}
						className="flex flex-row filter-button cursor-pointer"
						style={{ 
							height: '44px',
							alignItems: 'center', 
							justifyContent: 'center', 
							borderRadius: '0.75rem',
							borderBottomLeftRadius: isSortingOpen ? 0 : '0.75rem',
							borderBottomRightRadius: isSortingOpen ? 0 : '0.75rem',
							minWidth: '110px',
							maxWidth: '130px',
							background: '#22262e',
							transition: 'all 0.2s ease-in-out',
							boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
							padding: '0 12px'
						}}>
						<div style={{ fontSize: '12px', fontWeight: '500', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.1' }}>
							{orderBy === 'ev' ? 'Sort by EV%' : 'Sort by Time'}
						</div>
					</div>
				</div>

				<Popover
					anchorEl={sortingAnchorEl}
					open={isSortingOpen}
					onClose={() => {
						setIsSortingOpen(false);
					}}
					sx={{
						'& .MuiPaper-root': {
							backgroundColor: '#22262e',
							borderTopRightRadius: '0.75rem',
							borderBottomLeftRadius: '0.75rem',
							borderBottomRightRadius: '0.75rem',
							boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
						},
					}}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
					transformOrigin={{ vertical: 'top', horizontal: 'center' }}>
					<div className="rounded-xl" style={{ backgroundColor: '#22262e', width: 140 }}>
						<div
							onClick={() => {
								setOrderBy('ev');
								setOrder(orderBy === 'ev' && order === 'desc' ? 'asc' : 'desc');
								setIsSortingOpen(false);
							}}
							className={`p-3 filter-button cursor-pointer ${orderBy === 'ev' && 'filter-button-highlighted'}`}
							style={{ 
								color: 'white', 
								borderTopLeftRadius: '0.75rem', 
								borderTopRightRadius: '0.75rem',
								fontSize: '12px',
								fontWeight: '500',
								transition: 'background-color 0.2s ease'
							}}>
							Sort by EV%
						</div>
						<div
							onClick={() => {
								setOrderBy('time');
								setOrder(orderBy === 'time' && order === 'desc' ? 'asc' : 'desc');
								setIsSortingOpen(false);
							}}
							className={`p-3 filter-button cursor-pointer ${orderBy === 'time' && 'filter-button-highlighted'}`}
							style={{ 
								color: 'white', 
								borderBottomLeftRadius: '0.75rem', 
								borderBottomRightRadius: '0.75rem',
								fontSize: '12px',
								fontWeight: '500',
								transition: 'background-color 0.2s ease'
							}}>
							Sort by Time
						</div>
					</div>
				</Popover>
			</div>
		</div>
	);
};